module.exports = __webpack_public_path__ + "img/9.28740113.jpg";